import { AxiosError, AxiosResponse } from "axios";
import {
  IPayrollYearToDateListPayload,
  IPayrollYearToDateResponse,
} from "../models/YearToDate/PayrollYearToDate";
import { IResponse, IServerError } from "@websential/cosmic-v20";

import { IDropDownListResponse } from "../models/common/IDropDownListResponse";
import { IGetListRequest } from "../models";
import { IPayrollYearToDateAddEmployeePanel } from "../models/YearToDate/PayrollYearToDate/IPayrollYearToDateAddEmployeePanel";
import { IRemittanceYearToDate } from "../components/RemittanceYearToDate";

import http from "../common/http-commons";

export const YearToDateService = {
	/// PayrollYearToDate
	getYearToDatePayrollData: async (
		isApiCalls: boolean,
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IPayrollYearToDateListPayload
		| IServerError
		| IResponse
		| IPayrollYearToDateResponse[]
		| null
	> => {
		if (!isApiCalls) return null;
		// const fixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 2,
		// 	items: [
		// 		{
		// 			employeeId: "254654351351365463436413541",
		// 			id: "11",
		// 			name: "BBB",
		// 			period: "Monthly",
		// 			province: "On",
		// 			year: "2025",
		// 			total: "100.00",
		// 			regularGross: null,
		// 			ot15: null,
		// 			ot20: null,
		// 			vacationPayPaid: null,
		// 			holidayPay: null,
		// 			nonPeriodicEtc: null,
		// 			commission: null,
		// 			abc: null,
		// 			e1: null,
		// 			e2: null,
		// 			e3: null,
		// 			e4: null,
		// 			d1: null,
		// 			d2: null,
		// 			d3: null,
		// 			r1: null,
		// 			r2: null,
		// 			r3: null,
		// 			fedTax: null,
		// 			proTax: null,
		// 			cpp: null,
		// 			cpp2: null,
		// 			E11: null,
		// 			ppip: null,
		// 			RPP: null,
		// 			unionDues: null,
		// 			donations: null,
		// 		},
		// 		{
		// 			employeeId: "254654351351365463436413541",
		// 			id: "12",
		// 			name: "AAA",
		// 			period: "Monthly",
		// 			province: "AB",
		// 			year: "2025",
		// 			total: "100.00",
		// 			regularGross: null,
		// 			ot15: null,
		// 			ot20: null,
		// 			vacationPayPaid: null,
		// 			holidayPay: null,
		// 			nonPeriodicEtc: null,
		// 			commission: null,
		// 			abc: null,
		// 			e1: null,
		// 			e2: null,
		// 			e3: null,
		// 			e4: null,
		// 			d1: null,
		// 			d2: null,
		// 			d3: null,
		// 			r1: null,
		// 			r2: null,
		// 			r3: null,
		// 			fedTax: null,
		// 			proTax: null,
		// 			cpp: null,
		// 			cpp2: null,
		// 			E11: null,
		// 			ppip: null,
		// 			RPP: null,
		// 			unionDues: null,
		// 			donations: null,
		// 		},
		// 		{
		// 			employeeId: "254654351351365463436413541",
		// 			id: "13",
		// 			name: "ABC",
		// 			period: "Monthly",
		// 			province: "AB",
		// 			year: "2025",
		// 			total: "100.00",
		// 			regularGross: null,
		// 			ot15: null,
		// 			ot20: null,
		// 			vacationPayPaid: null,
		// 			holidayPay: null,
		// 			nonPeriodicEtc: null,
		// 			commission: null,
		// 			abc: null,
		// 			e1: null,
		// 			e2: null,
		// 			e3: null,
		// 			e4: null,
		// 			d1: null,
		// 			d2: null,
		// 			d3: null,
		// 			r1: null,
		// 			r2: null,
		// 			r3: null,
		// 			fedTax: null,
		// 			proTax: null,
		// 			cpp: null,
		// 			cpp2: null,
		// 			E11: null,
		// 			ppip: null,
		// 			RPP: null,
		// 			unionDues: null,
		// 			donations: null,
		// 		},
		// 		{
		// 			employeeId: "254654351351365463436413541",
		// 			id: "14",
		// 			name: "BCD",
		// 			period: "Monthly",
		// 			province: "BC",
		// 			year: "2025",
		// 			total: "100.00",
		// 			regularGross: null,
		// 			ot15: null,
		// 			ot20: null,
		// 			vacationPayPaid: null,
		// 			holidayPay: null,
		// 			nonPeriodicEtc: null,
		// 			commission: null,
		// 			abc: null,
		// 			e1: null,
		// 			e2: null,
		// 			e3: null,
		// 			e4: null,
		// 			d1: null,
		// 			d2: null,
		// 			d3: null,
		// 			r1: null,
		// 			r2: null,
		// 			r3: null,
		// 			fedTax: null,
		// 			proTax: null,
		// 			cpp: null,
		// 			cpp2: null,
		// 			E11: null,
		// 			ppip: null,
		// 			RPP: null,
		// 			unionDues: null,
		// 			donations: null,
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 100,

		// 			field: "id",
		// 			headerName: "Emp ID",
		// 			description: "",
		// 			type: "text",
		// 			frozenColumn: true,
		// 			sortable: false,
		// 			isEditable: false,
		// 			sequence: 0,
		// 			footer: null,
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 150,

		// 			field: "name",
		// 			headerName: "Name",
		// 			description: "",
		// 			type: "text",
		// 			frozenColumn: true,
		// 			sortable: false,
		// 			isEditable: false,
		// 			sequence: 1,
		// 			//   footer: "Total",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "period",
		// 			headerName: "Period",
		// 			description: "",
		// 			type: "text",
		// 			frozenColumn: true,
		// 			sortable: false,
		// 			isEditable: false,
		// 			sequence: 2,
		// 			//   footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "province",
		// 			headerName: "Province",
		// 			description: "",
		// 			type: "text",
		// 			frozenColumn: true,
		// 			sortable: false,
		// 			isEditable: false,
		// 			sequence: 2,
		// 			//   footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "year",
		// 			headerName: "Year",
		// 			description: "",
		// 			type: "text",
		// 			frozenColumn: true,
		// 			sortable: false,
		// 			isEditable: false,
		// 			sequence: 2,
		// 			footer: "Total",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "regularGross",
		// 			headerName: "Reg Gross",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "ot15",
		// 			headerName: "OT 1.5",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "ot20",
		// 			headerName: "OT 2.0",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},

		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "vacationPayPaid",
		// 			headerName: "Vac Pay Paid",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "holidayPay",
		// 			headerName: "Holiday Pay",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 130,

		// 			field: "nonPeriodicEtc",
		// 			headerName: "Non-Periodic",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "commission",
		// 			headerName: "Commission",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "abc",
		// 			headerName: "Abc",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},

		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "e1",
		// 			headerName: "E1",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "e2",
		// 			headerName: "E2",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "e3",
		// 			headerName: "E3",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "e4",
		// 			headerName: "E4",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "d1",
		// 			headerName: "D1",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},

		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "d2",
		// 			headerName: "D2",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "d3",
		// 			headerName: "D3",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "r1",
		// 			headerName: "R1",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "r2",
		// 			headerName: "R2",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},

		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "r3",
		// 			headerName: "R3",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "fedTax",
		// 			headerName: "Fed Tax",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "proTax",
		// 			headerName: "Pro Tax",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "cpp",
		// 			headerName: "Cpp",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "cpp2",
		// 			headerName: "CPP2",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "E11",
		// 			headerName: "E.I.",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "ppip",
		// 			headerName: "PPIP",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: false,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "RPP",
		// 			headerName: "Rpp",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "unionDues",
		// 			headerName: "Union Dues",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 		{
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			maxWidth: 120,

		// 			field: "donations",
		// 			headerName: "Donations",
		// 			description: "",
		// 			type: "number",
		// 			frozenColumn: false,
		// 			sortable: false,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			footer: "100.00",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(fixedResponse), 1000)
		// );

		try {
			const response: AxiosResponse<IPayrollYearToDateListPayload> =
				await http.get<IPayrollYearToDateListPayload>(
					"/v1/open-balance-assign-employee/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&order_by=" +
						data.order_by,
				);
			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createPayrollYearToDate: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse | any> => {
		if (requestPayload.openBalancePayrollData.id) {
			try {
				const response: AxiosResponse<any> = await http.put<any>(
					`/v1/open-balance-payroll/${requestPayload.openBalancePayrollData.id}/`,
					requestPayload,
				);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 404) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<any> = await http.post<any>(
				"/v1/open-balance-payroll/",
				requestPayload,
			);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 404) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getPayrollYearToDateAddEmployeePanel: async (
		clientId: string,
		taxYear: number,
	): Promise<
		IPayrollYearToDateAddEmployeePanel | IServerError | IResponse | null
	> => {
		if (!taxYear) return null;
		const response: AxiosResponse<IPayrollYearToDateAddEmployeePanel> =
			await http.get<IPayrollYearToDateAddEmployeePanel>(
				`/v1/open-balance-assign-employee/ddl?client_id=${clientId}&tax_year=${taxYear}`,
			);
		
		if (response.status === 200) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};

		// let response: any = {
		// 	clientId: "6945009f7f105556f1656af8",
		// 	assigned: [
		// 		{
		// 			text: "Panday G",
		// 			value: "694501ee7f105556f1656aff",
		// 			id: "694501ee7f105556f1656aff",
		// 		},
		// 	],
		// 	unassigned: [
		// 		{
		// 			text: "Shaka Dil jalay",
		// 			value: "6945027c7f105556f1656b04",
		// 			id: "6945027c7f105556f1656b04",
		// 		},
		// 	],
		// };

		// return new Promise((resolve) => setTimeout(() => resolve(response), 1000));
	},

	delPayrollYearToDateById: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
		
			const response: AxiosResponse<string> = await http.put<string>(
				`/v1/open-balance-payroll/`,
				{
				
					clientId: delPayload.clientId,
					taxYear: delPayload.taxYear,
					employeeIds: delPayload.employeeIds,
				},
			
			);

			if (response.status === 204) {
				return "Payroll Year to Date has been deleted successfully";
			} else if (response.status === 200) {
				return "Payroll Year to Date has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createPayrollYearToDateAddEmployeePanel: async (
		// clientId:string,
		requestPayload: any,
		// taxYear:number,
	): Promise<any | IServerError | IResponse> => {
		let response: AxiosResponse<any>;
		response = await http.put<any>(
			`/v1/open-balance-assign-employee/assign-unassign?association_flag=${requestPayload.flag}`, // open balance api
			{ items: requestPayload.items },
			// `/v1/statutory-holiday-employee-eligibility/${requestPayload.employeeId}/?association_flag=${requestPayload.flag}` // statutory api
			// `/v1/open-balance-assign-employee/?client_id=${clientId}&employee_id=${request.employeeId}&tax_year=${taxYear}&association_flag=${requestPayload.flag}`
		);

		if (response.status === 201 || response.status === 200) {
			return response.data;
		} else if (response.status === 200) {
			let responseWithFlag = {
				client: response.data,
				status: requestPayload.flag,
			};
			return responseWithFlag;
			// return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "400 Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getYearsDDL: async (
		clientId: string,
		taxYear?: number,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
				IDropDownListResponse[]
			>(
				`/v1/open-balance-payroll/active_years_after_company_schedule_start_date_ddl?client_id=${clientId}&tax_year=${taxYear}`,
			);
			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},

	// getAssignEmployeeDDL: async (
	// 	clientId: string,
	// ): Promise<any | IServerError | IResponse | null> => {
	// 	try {
	// 		const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
	// 			IDropDownListResponse[]
	// 		>(
	// 			`/v1/open-balance-assign-employee/ddl?client_id=${clientId}`
	// 		);
	// 		if (response.status === 200) {
	// 			return response.data;
	// 		}

	// 		return {
	// 			status: false,
	// 			message: "Something went wrong please try again later.",
	// 		};
	// 	} catch {}
	// },



	/////////////////////////////// Remittance Year To Date ///////////////////////////////

	createRemittanceYearToDate: async (
		requestPayload: any,
	): Promise<IRemittanceYearToDate | IServerError | IResponse | any> => {
		if (requestPayload.payload.id) {
			try {
				const response: AxiosResponse<any> =
					await http.put<IRemittanceYearToDate>(
						`/v1/open-balance-remittance/${requestPayload.payload.id}/`,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 404) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<any> =
				await http.post<IRemittanceYearToDate>(
					"/v1/open-balance-remittance/",
					requestPayload.payload,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 404) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getDataRemittanceYearToDateById: async (
		id: string | undefined,
		// clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IRemittanceYearToDate | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<IRemittanceYearToDate> =
				await http.get<IRemittanceYearToDate>(
					// `/v1/employee-bank/${id}/`
					`/v1/open-balance-remittance/${id}/`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	delRemittanceYearToDateById: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/open-balance-remittance/${delPayload.remittanceYearToDateId}/`,
			);

			if (response.status === 204) {
				return "open balance remittance has been deleted successfully";
			} else if (response.status === 200) {
				return "open balance remittance has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},


	/////////////////////////////// Import Year To Date ///////////////////////////////

	getImportYearToDate: async (
		requestPayload: any,
	): Promise<string | IServerError | IResponse> => {
		const response = await http.post<string>(
			`/v1/t4-slips-csv/import-csv/?client_id=${requestPayload.id}&tax_year=${requestPayload.taxYear}`,
			requestPayload.formData,
		);
		if (response.status === 200) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
};
